<div class="w-[1200px]">
  <h2 class="font-semibold mb-4">Поиск локации</h2>
  <div class="flex gap-x-2">
    <tui-combo-box
      class="w-full"
      tuiTextfieldSize="m"
      [formControl]="search"
      (searchChange)="onSearchChange($event)"
    >
      Поиск
      <tui-data-list-wrapper
        *tuiDataList
        [items]="results$ | async"
        [itemContent]="content"
      ></tui-data-list-wrapper>
    </tui-combo-box>
  </div>
  <div class="py-2" *tuiLet="markerPosition$ | async as position">
    <google-map
      [mapId]="googleMapService.mapId"
      (mapClick)="onMapClick($event)"
      width="100%"
      height="400px"
      [options]="(options$ | async)!"
    >
      @if (position) {
        <map-advanced-marker
          #marker="mapAdvancedMarker"
          (mapClick)="openInfoWindow(marker)"
          [position]="position"
          [options]="markerOptions"
        />
        <map-info-window>
          {{ positionAddress$ | async }}
        </map-info-window>
      }
    </google-map>
  </div>
  <div class="flex justify-between">
    <button
      tuiButton
      size="m"
      appearance="outline"
      (click)="markerPosition$.next(null)"
    >
      Очистить
    </button>
    <button
      tuiButton
      size="m"
      appearance="primary"
      [disabled]="(markerPosition$ | async) === null"
      (click)="onSubmit()"
    >
      Выбрать
    </button>
  </div>
</div>

<ng-template #content let-position>
  <div class="template">
    {{ position.formatted_address }}
  </div>
</ng-template>
